import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { MobileTopBar, MobileBottomNav } from './MobileAppBars';
import { NewChallengeDialog } from './NewChallengeDialog';
import { useAppShellData } from './useAppShellData';

interface LayoutProps {
  children: React.ReactNode;
}

// App shell: sidebar on desktop, top bar + bottom tab bar on phones.
// Pages render inside a 1120px column with 24px vertical rhythm.
export const Layout = ({ children }: LayoutProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { pathname } = useLocation();
  const { profile, myGroups } = useAppShellData(pathname);
  const [newChallengeOpen, setNewChallengeOpen] = useState(false);
  const openNewChallenge = () => setNewChallengeOpen(true);

  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: 'var(--surface)', color: 'var(--fg)' }}>
      {isDesktop && <AppSidebar profile={profile} myGroups={myGroups} onNewChallenge={openNewChallenge} />}

      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        {!isDesktop && <MobileTopBar profile={profile} />}

        <Box component="main" sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <Box sx={{ maxWidth: 1120, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, pt: { xs: 2.5, md: 3.5 }, pb: 5, display: 'flex', flexDirection: 'column', gap: 3 }}>
            {children}
          </Box>
        </Box>

        {!isDesktop && <MobileBottomNav onNewChallenge={openNewChallenge} />}
      </Box>

      <NewChallengeDialog open={newChallengeOpen} onClose={() => setNewChallengeOpen(false)} groups={myGroups} />
    </Box>
  );
};
